const CategoriesPage = () => {
  return (
    <div className="space-y-6">
      <div className="mb-2">
        <h1 className="text-2xl font-bold text-grey-900 mb-1">Categories</h1>
        <p className="text-sm text-grey-500">
          Manage your product categories
        </p>
      </div>

      <div className="bg-white rounded-xl p-12 text-center">
        <p className="text-grey-500">Categories management coming soon...</p>
      </div>
    </div>
  );
};

export default CategoriesPage;

